import {
  Document,
  Page,
  View,
  Text,
  Image,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

import barlowFont from "./../Barlow/Barlow-SemiBold.ttf";
import barlowFontRegular from "./../Barlow/Barlow-Regular.ttf";
import logo_constancia from "./../../../assets/iconos/logo_constancia.png";
import firma_constacia_matricula from "./../../../assets/iconos/firma_constacia_matricula.jpg";

Font.register({ family: "Barlow", src: barlowFont });

Font.register({ family: "BarlowRegular", src: barlowFontRegular });



const FechaDescarga = () => {
  const date = new Date();
  const options = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    hour12: true, // esta opción muestra la hora en formato de 12 horas
    timeZone: "America/Lima",
  };

  const formattedDate = date.toLocaleString("es-PE", options);

  return formattedDate;
};



const FechaFooter = (fecha) => {

  const parts = fecha?.split(/\/|\s|:/);
  const day = parts[0].padStart(2, "0");
  const monthNumber = parseInt(parts[1], 10);
  const year = parts[2];


  const month = new Date(year, monthNumber - 1).toLocaleString("es-PE", {
    month: "long",
  });

  return `${day} de ${month} de ${year}`;
};

const ConstanciaMatricula = ({ datatosConstacia }) => {

  const styles = StyleSheet.create({
    page: {
      padding: 60,
      height: "100%",
      position: "relative",
    },
    imageContainer: {
      height: "100px",
      width: "100%",

      display: "flex",
      flexDirection: "row",

      justifyContent: "center",
    },
    image: {
      width: "270px",
      height: "90px",
    },
    table: {
      alignItems: "center",
      display: "table",
      width: "auto",
      borderStyle: "solid",
      borderColor: "#aca9a9",
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      fill: "#c7c7c7ed",
    },
    tableRow: {
      flexDirection: "row",
    },
    tableCol: {
      alignItems: "center",
      borderStyle: "solid",
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
      borderColor: "#aca9a9",
    },
    tableCell: {
      width: "100%",
      padding: "0 5px 0 5px",
      marginTop: 5,
      marginBottom: 5,
      fontSize: 10,
      textAlign: "left",
    },
    fontFamilys: {
      fontFamily: "BarlowRegular",
    },
    title: {
      textAlign: "center",
      fontWeight: "700",
      textTransform: "uppercase",
      fontFamily: "Barlow",
    },
    titleRight: {
      textAlign: "right",
      marginTop: "10px",
      marginBottom: "10px",
      fontSize: "12px",
      fontFamily: "Barlow",
    },
    textUppercase: {
      textTransform: "uppercase",
    },
    textResumen: {
      fontSize: "12px",
      fontFamily: "Barlow",
    },
    textFooter: {
      fontSize: "10px",
      fontFamily: "Barlow",
    },
    textNormal: {
      fontFamily: "BarlowRegular",
    },
    paddingResunen: {
      padding: "15px 0 15px 0",
    },
    tarjetaResumen: {
      width: "120px",
      padding: "8px",
      border: "1.5px solid #adadad",
      borderRadius: "5px",
      marginRight: "10px",
      fontSize: "11px",
    },
    contentTarjeta: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",

      width: "100%",
    },
    footer: {
      width: "100%",
      textAlign: "center",
      position: "absolute",
      left: "10%",
      bottom: 25,
      fontFamily: "BarlowRegular",
      fontSize: "12px",
    },
    header: {
      width: "100%",
      textAlign: "center",
      position: "absolute",
      left: "10%",
      top: 25,
      fontFamily: "BarlowRegular",
      fontSize: "12px",
    },
    imgFirma: {
      width: "120px",
      height: "65px",
    },
  });

  const watermarkStyle = {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    left: 50,
    position: "absolute",
    top: 0,
    width: "100%",

  };

  const textWatermarkStyle = {
    color: "rgba(0, 0, 0, 0.2)",
    fontSize: 80,
    fontFamily: "Barlow",
    fontWeight: 700,
    textTransform: "uppercase",
    transform: "rotate(-45deg)",
    userSelect: "none",
    textAlign: "center",
  };

  const paginate = (array = [], firstPageSize, restPageSize) => {
    const firstPage = array?.slice(0, firstPageSize);
    const restPages = array?.slice(firstPageSize);

    const restPagesResult = restPages?.reduce((result, item, index) => {
      const pageIndex = Math.floor(index / restPageSize);
      if (!result[pageIndex]) {
        result[pageIndex] = [];
      }
      result[pageIndex].push(item);
      return result;
    }, []);

    return [firstPage, ...restPagesResult];
  };
  return (
    <Document size="A4" key={"1a"}>
      {paginate(datatosConstacia, 5, 15)?.map((item, index) => {
        return (
          <Page style={styles?.page} key={index} wrap>
            <View fixed style={styles.header}>
              <Text style={{ textAlign: "left", fontSize: "10px" }}>
                {FechaDescarga()}
              </Text>
            </View>
            <View style={styles?.imageContainer}>
              <Image style={styles?.image} src={logo_constancia} />
            </View>
            {index == 0 && (
              <>
                <View>
                  <Text style={styles.title}>
                    {/* CONSTANCIA DE MATRICULA 2023 - V */}
                    CONSTANCIA DE MATRÍCULA {item[0]?.speriodo}
                  </Text>

                  <Text style={styles.titleRight}>
                    OAMRA C-N°: {item[0]?.dresolucion}
                  </Text>
                </View>
                <View style={styles.textResumen}>
                  <Text style={{ textAlign: "justify" }}>
                    QUIENES SUSCRIBEN, EL JEFE DE LA OFICINA DE ADMISIÓN,
                    MATRÍCULA Y REGISTRO ACADÉMICO Y EL SECRETARIO GENERAL DE LA
                    UNIVERSIDAD PERUANA CAYETANO HEREDIA
                    <Text
                      style={{ ...styles.textNormal, textAlign: "justify" }}
                    >
                      {" "}
                      dejan constancia:
                    </Text>
                  </Text>
                  <Text style={{ ...styles.textNormal, textAlign: "justify" }}>
                    Que, don(ña){" "}
                    <Text
                      style={{ ...styles.textResumen, textAlign: "justify" }}
                    >
                      {/* GUILLERMO TINOCO, ADRIANA MELANY */}
                      {item[0]?.dpersona}
                    </Text>{" "}
                    con DNI {item[0]?.ndoc_identidad}, se encuentra
                    matriculado(a) en el semestre académico {item[0]?.speriodo}{" "}
                    en la{" "}
                    <Text
                      style={{ ...styles.textResumen, textAlign: "justify" }}
                    >
                      {" "}
                      {/* CARRERA PROFESIONAL DE PSICOLOGÍA */}
                      {item[0]?.dcarrera}
                    </Text>{" "}
                    de la
                    <Text
                      style={{ ...styles.textResumen, textAlign: "justify" }}
                    >
                      {" "}
                      {item[0]?.dfacultad}
                    </Text>
                  </Text>
                </View>
                <View style={styles.textResumen}>
                  <Text style={styles.paddingResunen}>
                    RESUMEN DE CURSOS MATRICULADOS
                  </Text>
                  <View style={styles.contentTarjeta}>
                    <View style={styles.tarjetaResumen} wrap>
                      <Text>Total de cursos matriculados</Text>
                      <Text style={{ marginTop: "4px" }}>
                        {item[0]?.total_cursos}
                      </Text>
                    </View>
                    <View style={styles.tarjetaResumen} wrap>
                      <Text>Total de créditos primera matrícula</Text>
                      <Text style={{ marginTop: "4px" }}>
                        {item[0]?.total_creditos}
                      </Text>
                    </View>
                    <View style={styles.tarjetaResumen} wrap>
                      <Text>Total de créditos matriculados</Text>
                      <Text style={{ marginTop: "4px" }}>
                        {item[0]?.total_creditos_usados}
                      </Text>
                    </View>
                  </View>
                </View>
              </>
            )}

            <View style={styles.textResumen}>
              <Text style={styles?.paddingResunen}>
                ASIGNATURAS MATRICULADAS
              </Text>

              <View style={styles.table}>
                <View style={styles.tableRow}>
                  <View style={{ ...styles.tableCol, width: "15%" }}>
                    <Text style={styles.tableCell}>Código Curso</Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "15%" }}>
                    <Text style={styles.tableCell}>Nivel/Ciclo</Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "40%" }}>
                    <Text style={styles.tableCell}>Nombre asignatura</Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "15%" }}>
                    <Text style={styles.tableCell}>Créditos</Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "15%" }}>
                    <Text style={styles.tableCell}>Num. Veces</Text>
                  </View>
                </View>

                {item.map((item2, index2) => {
                  return (
                    <View key={index2} style={styles.tableRow}>
                      <View style={{ ...styles.tableCol, width: "15%" }}>
                        <Text
                          style={{ ...styles.tableCell, ...styles.fontFamilys }}
                        >
                          {/* I0853 */}
                          {item2.scurso}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "15%" }}>
                        <Text
                          style={{ ...styles.tableCell, ...styles.fontFamilys }}
                        >
                          {/* 1 */}
                          {item2.nciclo}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "40%" }}>
                        <Text
                          style={{ ...styles.tableCell, ...styles.fontFamilys }}
                        >
                          {/* MATEMATICAS BASICAS */}
                          {item2.dcurso}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "15%" }}>
                        <Text
                          style={{ ...styles.tableCell, ...styles.fontFamilys }}
                        >
                          {/* 4 */}
                          {item2.ncredito}
                        </Text>
                      </View>
                      <View style={{ ...styles.tableCol, width: "15%" }}>
                        <Text
                          style={{ ...styles.tableCell, ...styles.fontFamilys }}
                        >
                          {/* 1 */}
                          {item2.nvez}
                        </Text>
                      </View>
                    </View>
                  );
                })}
              </View>

              <View
                style={{ margin: "10px 0 10px 0", ...styles.fontFamilys }}
                fixed
              >
                <Text>Lima, {FechaFooter(item[0]?.fregistro)}.</Text>
                <Text style={{ textAlign: "right", marginTop: "18px" }}>
                  <Image
                    style={styles?.imgFirma}
                    src={firma_constacia_matricula}
                  />
                </Text>
              </View>
            </View>
            <View style={styles.footer} fixed>
              <Text style={{ width: "100%", fontSize: "10px" }}>
                Av. Honorio Delgado 430, Urbanización Ingeniería, San Martín de
                Porres
              </Text>
              <Text style={{ width: "100%", ...styles.textFooter }}>
                www.upch.edu.pe
              </Text>

              <Text
                style={{ textAlign: "right", fontSize: "10px" }}
                render={({ pageNumber, totalPages }) =>
                  `${pageNumber} / ${totalPages}`
                }
                fixed
              />
            </View>   
          </Page>
        );
      })}
    </Document>
  );
};

export default ConstanciaMatricula;
